import { Constants } from '@pwc/pwc-deals-web-common';
import { Button } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import useLock from 'common/hooks/useLock';
import ShowForRole from '../../../features/security/ShowForRole';
import styles from './AddInsightButton.module.scss';

type Props = {
  projectId: string | number;
  contentThreadId: number | null;
  onClick: () => void;
};
const AddInsightButton = ({ projectId, contentThreadId, onClick }: Props) => {
  const { isLocked } = useLock({
    contentThreadId,
  });
  const { t } = useTranslation('');

  return (
    <ShowForRole
      projectId={projectId}
      roles={Constants.USER_ROLE_GROUPS.INTERNAL_READWRITE}
    >
      <div className={styles.container}>
        <Button
          className={`button-link ${styles.button}`}
          icon="light-bulb"
          onClick={onClick}
          type="button"
          disabled={isLocked}
          iconClasses={undefined}
        >
          {t('addAnInsight')}
        </Button>
      </div>
    </ShowForRole>
  );
};

export default AddInsightButton;
